// P43-05: the "support is not reachable right now" notice. Raised when the Synova
// widget cannot be loaded or opened (see services/SynovaWidget.js); the shell
// shows a calm message and the app carries on.
export default {
  namespaced: true,
  state: {
    unavailable: false,
  },
  mutations: {
    setUnavailable: (state, b) => (state.unavailable = !!b),
  },
  actions: {
    show: ({ commit }) => commit('setUnavailable', true),
    hide: ({ commit }) => commit('setUnavailable', false),
  },
}
